import { MLS } from '@aloft/toolkit-shared';
import { Flex, IconButton, Input, Select } from '@aloft/toolkit-sui';
import { Controller, useFormContext } from 'react-hook-form';

export const MLSInput = ({
  index,
  onRemove,
}: {
  index?: number;
  onRemove?: (index: number) => void;
}) => {
  const { control, resetField } = useFormContext();
  const mlsOptions = MLS._keys
    .sort((a, b) => MLS[a].shortName.localeCompare(MLS[b].shortName))
    .filter((key) => MLS[key].isActive)
    .map((key) => ({ label: MLS[key].shortName, value: key }));

  const fieldName = index === undefined ? '' : `mlsListings.${index}.`;
  return (
    <Flex width="100%" gap={3} flexDirection="column">
      <Flex gap={2} position="relative">
        {index !== undefined && index > 0 && (
          <IconButton
            size="sm"
            variant="tertiary"
            __dangerDoNotUseSx={{ position: 'absolute', right: '0', zIndex: 1 }}
            icon="delete-bin"
            ariaLabel="Remove listing"
            onClick={() => onRemove?.(index)}
          />
        )}
        <Controller
          control={control}
          key="mls"
          name={`${fieldName}mls`}
          render={({ field }) => (
            <Select
              options={[{ label: '', value: '' }, ...mlsOptions,]}
              {...field}
              onChange={(val) => field.onChange(val ?? '')}
              label="MLS"
            />
          )}
        />
        <Controller
          control={control}
          key="mlsListingID"
          name={`${fieldName}mlsListingID`}
          render={({ field }) => (
            <Input
              type="text"
              {...field}
              label="MLS Listing ID"
              onClear={() =>
                resetField(`${fieldName}mlsListingID`, {
                  defaultValue: '',
                })
              }
            />
          )}
        />
      </Flex>
    </Flex>
  );
};
